import { useAppDispatch, useAppSelector } from '../../hooks/redux-hooks';
import { setToastInfo } from '../../store/common.slice';
import { ToastType } from '../../types/common.types';

const AppToast = () => {
  const { toastInfo } = useAppSelector((state) => state.common);
  const dispatch = useAppDispatch();

  const getToastType = () => {
    switch (toastInfo?.type) {
      case ToastType.ERROR:
        return 'text-red-500 bg-red-100 rounded-lg dark:bg-red-800 dark:text-red-200';
      case ToastType.SUCCESS:
        return 'text-green-500 bg-green-100 rounded-lg dark:bg-green-800 dark:text-green-200';
    }
  };
  setTimeout(() => {
    dispatch(
      setToastInfo({
        isOpen: false,
        message: '',
      })
    );
  }, 10000);
  return (
    <>
      <div
        id="toast-success"
        className="
          flex items-center w-full max-w-xs p-4 mb-4 text-gray-500 fixed bottom-6 right-6 z-[5]
          bg-white rounded-lg shadow dark:text-gray-400 dark:bg-gray-800
        "
        role="alert"
      >
        <div
          className={`inline-flex items-center justify-center flex-shrink-0 w-8 h-8 ${getToastType()}`}
        >
          <i
            className={
              toastInfo?.type === ToastType.ERROR ? 'icon-cross' : 'icon-check'
            }
          />
          <span className="sr-only">Check icon</span>
        </div>
        <div className="ms-3 text-sm font-normal">{toastInfo?.message}</div>
        <button
          type="button"
          className="ms-auto -mx-1.5 -my-1.5 bg-white text-gray-400
          hover:text-gray-900 rounded-lg focus:ring-2 focus:ring-gray-300 p-1.5
          hover:bg-gray-100 inline-flex items-center justify-center h-8 w-8
          dark:text-gray-500 dark:hover:text-white dark:bg-gray-800 dark:hover:bg-gray-700
          "
          onClick={() =>
            dispatch(
              setToastInfo({
                isOpen: false,
                message: '',
              })
            )
          }
          data-dismiss-target="#toast-success"
          aria-label="Close"
        >
          <span className="sr-only">Close</span>
          <i className="icon-cross text-lg" />
        </button>
      </div>
    </>
  );
};

export default AppToast;
